import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InteractorResponse } from '../../models/interactor-response';
import { AppConstants } from '../../constants/app-constants';
import { AbstractOrdersSearchResaltViewTemplateApiService } from '../abstract/abstract-orders-search-resalt-view-template-api-service';
import {
  OrdersSearchResaltTableColumnViewModel,
  OrdersSearchResaltViewTemplateModel,
} from 'src/app/store/orders-search-resalt-view-template/model';

const baseUrl = `/api/ordersSearchResaltView`;

@Injectable()
export class OrdersSearchResaltViewTemplateApiService extends AbstractOrdersSearchResaltViewTemplateApiService {
  private http = inject(HttpClient);

  getViewForUser(userId: number): Observable<InteractorResponse<OrdersSearchResaltViewTemplateModel>> {
    return this.http.get<InteractorResponse<OrdersSearchResaltViewTemplateModel>>(`${baseUrl}/${userId}`);
  }

  setViewForUser(
    userId: number,
    viewTemplate: OrdersSearchResaltTableColumnViewModel[]
  ): Observable<InteractorResponse<OrdersSearchResaltViewTemplateModel>> {
    return this.http.put<InteractorResponse<OrdersSearchResaltViewTemplateModel>>(`${baseUrl}/${userId}`, viewTemplate);
  }
}
